import ActionLogPanel from 'components/table/ActionLogPanel';
import { RoundActionLogEntry } from 'types/game';

interface TableSidePanelProps {
  actions?: RoundActionLogEntry[];
  roundNumber?: number;
  currencySymbol?: string;
  currencyCode?: string | null;
}

/** Desktop round log rail — table chat opens near hero player info. */
export default function TableSidePanel({
  actions = [],
  roundNumber = 0,
  currencySymbol,
  currencyCode,
}: TableSidePanelProps) {
  return (
    <aside className="tp-side-panel tp-floating-rail tp-floating-rail-right z-40 hidden xl:flex">
      <div className="tp-side-panel-tabs">
        <button type="button" className="tp-side-panel-tab active">
          Round log
        </button>
      </div>
      <div className="tp-side-panel-log-wrap">
        <ActionLogPanel
          embedded
          actions={actions}
          roundNumber={roundNumber}
          currencySymbol={currencySymbol}
          currencyCode={currencyCode}
        />
      </div>
    </aside>
  );
}
